import { Box, Button, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../../content/Content";
import { MdWatchLater } from "react-icons/md";
import "./ChartIdeas.component.css";
import { useState } from "react";
import ChartIdeasDetails from "./ChartIdeasDetails";
import { useEffect } from "react";
const ChartIdeas = () => {
  const [chartData,setChartData ] = useState([])
  const [openBtn, setBtn] = useState();
  const ChartIdeasData = [
    {
      id: 1,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag3,
      flag2: Img.flag4,
      cover: Img.ChartCover1,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },

    {
      id: 2,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag1,
      flag2: Img.flag2,
      cover: Img.ChartCover2,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },

    {
      id: 3,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag1,
      flag2: Img.flag4,
      cover: Img.ChartCover3,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },

    {
      id: 4,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag3,
      flag2: Img.flag1,
      cover: Img.ChartCover4,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },

    {
      id: 5,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag1,
      flag2: Img.flag3,
      cover: Img.ChartCover5,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },

    {
      id: 6,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag3,
      flag2: Img.flag1,
      cover: Img.ChartCover6,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },

    {
      id: 7,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag4,
      flag2: Img.flag4,
      cover: Img.ChartCover7,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },

    {
      id: 8,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag3,
      flag2: Img.flag3,
      cover: Img.ChartCover8,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },

    {
      id: 9,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag1,
      flag2: Img.flag1,
      cover: Img.ChartCover9,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    },
  ];

  useEffect(()=>{
    setChartData({
      id: 1,
      name: "AUDCNH",
      date_time: "April 02. 2023",
      time: "11:51PM",
      flag: Img.flag3,
      flag2: Img.flag4,
      cover: Img.ChartCover1,
      description:
        "We built Ideas so that anyone, anywhere in the world, can easily share their thoughts and opinions on global markets. Now, thousands and thousands of users create Ideas every day from our charting platform: discussing their predictions, market analysis and general trade set-ups with others in the community. Why are Ideas so important? Well, in our opinion, there might be loads of other places where you can talk about finance on the web, but very few of them offer the same highly-bespoke and trustworthy social experience as we do.",
      details: false,
      active: true,
    })
  }, [])
  function handleClick(e) {
    setChartData(e);
    setBtn(e.id);
  }


  return (
    <VStack w="100%">
      <VStack flexDir="row" alignItems="center">
        <Stack w="70%" bg="rgba(245, 245, 255, 1)" pt="80px">
          <Stack w={{base:"100%", sm:"100%", md:'95%', lg:"90%", xl:"85%"}} mx="auto" flexDir="row" alignItems="center">
            <Box w="60%">
              <Text
                fontFamily="'Roboto',sans-serif"
                fontSize="40px"
                fontWeight="700"
                textAlign="left"
                ml="10px"
              >
                Most resent chart ideas
              </Text>
            </Box>
            <Box w="40%" display={"flex"} justifyContent="flex-end">
              <Button
                color="#fff"
                bg="#000000"
                borderRadius="6px"
                fontFamily="'Roboto',sans-serif"
                fontSize="14px"
                fontWeight="600"
                textAlign="center"
                _hover={{ backgroundColor: "#000000" }}
              >
                Index
              </Button>
              <Button
                mx="8px"
                color="#fff"
                bg="#0071C1"
                borderRadius="6px"
                fontFamily="'Roboto',sans-serif"
                fontSize="14px"
                fontWeight="600"
                textAlign="center"
                _hover={{ backgroundColor: "#0071C1" }}
              >
                FX
              </Button>
              <Button
                borderRadius="6px"
                color="#fff"
                bg="#0071C1"
                fontFamily="'Roboto',sans-serif"
                fontSize="14px"
                fontWeight="600"
                textAlign="center"
                _hover={{ backgroundColor: "#0071C1" }}
              >
                Crypto
              </Button>
            </Box>
          </Stack>
          <Stack w={{base:"100%", sm:"100%", md:'95%', lg:"90%", xl:"85%"}} mx="auto" flexDir="row" alignItems="center">
            <Box w="100%">
              {/* Video Box */}
              <Stack
                flexWrap="wrap"
                justifyContent="center"
                flexDir="row"
                gap="0"
                w="100%"
              >
                {ChartIdeasData.map((item) => (
                  <Box
                    key={item.id}
                    w={{ base: "50%", md: "50%", lg:"50%" ,xl: "33%" }}
                    bg="transparent"
                    p="15px"
                  >
                    <Box
                      w="100%"
                      display="flex"
                      borderRadius="32px"
                      bg="#FFFFFF"
                      alignItems=""
                      h="300px"
                      p="20px"
                      flexWrap="wrap"
                      transition="0.3s"
                      className="chartIdea-box"
                      _hover={{
                        bg: "#601FEB",
                      }}
                    >
                      {/* topbar */}
                      <Stack w="100%" flexDir="row" py="10px">
                        <Box display="flex" w="60%">
                          <Image src={item.flag} w="47px" h="30px" />
                          <Image src={item.flag2} w="47px" h="30px" mx="15px" />
                        </Box>
                        <Box w="40%">
                          <Text
                            fontFamily="'Roboto', sans-serif"
                            fontSize="18px"
                            fontWeight="600"
                            color="#000000"
                            textAlign="end"
                          >
                            {item.name}
                          </Text>
                        </Box>
                      </Stack>
                      <Stack w="100%" flexDir="row" pb="10px">
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          alignItems="center"
                          w="50%"
                        >
                          <Text
                            fontFamily="'Poppins', sans-serif"
                            fontSize="14px"
                            fontWeight="600"
                            color="#000000"
                          >
                            April 02. 2023
                          </Text>
                        </Box>
                        <Box
                          w="50%"
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          <MdWatchLater
                            style={{ fontSize: "20px" }}
                            className="icon-color"
                          />
                          <Text
                            fontFamily="'Poppins', sans-serif"
                            fontSize="16px"
                            fontWeight="600"
                            color="#000000"
                          >
                            {item.name}
                          </Text>
                        </Box>
                      </Stack>

                      <Stack position="relative" w="100%">
                        <Image
                          src={item.cover}
                          w="100%"
                          h="146px"
                          borderRadius="25px"
                        />
                        <Box
                          position={"absolute"}
                          top="0"
                          left="0"
                          right="0"
                          h="100%"
                          w="100%"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Button
                            borderRadius="70px"
                            onClick={() => handleClick(item)}
                            bg={item.id === openBtn ? "#601FEB" : " white"}
                            color={item.id === openBtn ? "white" : " #000"}
                            fontFamily="'Roboto', sans-serif"
                            fontSize="16px"
                            fontWeight="400"
                          >
                            {item.id === openBtn ? "Show less" : "Show More"}
                          </Button>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                ))}
              </Stack>

              <Stack py="25px" w="100%">
                {/* Pagination */}
                <Box display="flex" justifyContent="flex-end" w="100%">
                  <Button
                    h="31px"
                    width="31px"
                    borderRadius="8px"
                    bg="rgba(255, 255, 255, 1)"
                    color="rgba(158, 158, 158, 1)"
                    fontFamily="'Poppins', sans-serif"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="400"
                    fontSize="14px"
                    mx="5px"
                  >
                    1
                  </Button>
                  <Button
                    h="31px"
                    width="31px"
                    borderRadius="8px"
                    bg="rgba(149, 151, 171, 1)"
                    color="rgba(255, 255, 255, 1)"
                    fontFamily="'Poppins', sans-serif"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="400"
                    fontSize="14px"
                    mx="5px"
                  >
                    2
                  </Button>
                  <Button
                    h="31px"
                    width="31px"
                    borderRadius="8px"
                    bg="rgba(149, 151, 171, 1)"
                    color="rgba(255, 255, 255, 1)"
                    fontFamily="'Poppins', sans-serif"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="400"
                    fontSize="14px"
                    mx="5px"
                  >
                    3
                  </Button>
                  <Button
                    h="31px"
                    width="31px"
                    borderRadius="8px"
                    bg="rgba(149, 151, 171, 1)"
                    color="rgba(255, 255, 255, 1)"
                    fontFamily="'Poppins', sans-serif"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="400"
                    fontSize="14px"
                    mx="5px"
                  >
                    4
                  </Button>
                  <Button
                    h="31px"
                    width="31px"
                    borderRadius="8px"
                    bg="rgba(149, 151, 171, 1)"
                    color="rgba(255, 255, 255, 1)"
                    fontFamily="'Poppins', sans-serif"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="400"
                    fontSize="14px"
                    mx="5px"
                  >
                    5
                  </Button>
                  <Button
                    h="31px"
                    width="31px"
                    borderRadius="8px"
                    bg="rgba(149, 151, 171, 1)"
                    color="rgba(255, 255, 255, 1)"
                    fontFamily="'Poppins', sans-serif"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="400"
                    fontSize="14px"
                    mx="5px"
                  >
                    ...
                  </Button>
                  <Button
                    h="31px"
                    width="31px"
                    borderRadius="8px"
                    bg="rgba(149, 151, 171, 1)"
                    color="rgba(255, 255, 255, 1)"
                    fontFamily="'Poppins', sans-serif"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="400"
                    fontSize="14px"
                    mx="5px"
                  >
                    17
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Stack>
        <Stack w="30%" bg="rgba(255, 255, 255, 1)" pt="80px" justifyContent="center" h="100%">
          <ChartIdeasDetails {...chartData}/>
        </Stack>
      </VStack>
    </VStack>
  );
};

export default ChartIdeas;
